import { PropsWithChildren, PureComponent } from 'react';
import styled from 'styled-components';

import { DefaultHeader } from '@formstack/phoenix/components/Typography';
import { Spacing } from '@formstack/phoenix/components/spacing';

import { handleError } from '@/common/utils/error';
import ErrorStateImg from '@/images/ErrorStateImg.svg';
import { ComponentResource } from '@/resources/interface';

type ErrorBoundaryResource = ComponentResource<{
  anErrorHasOccurred: string;
}>;
type ErrorBoundaryProps = ErrorBoundaryResource & PropsWithChildren;

type ErrorBoundaryState = {
  hasError: boolean;
};

const StyledContainer = styled.div`
  padding-top: ${Spacing.ExtraLarge};
  text-align: center;
`;

const StyledImage = styled.img`
  height: 280px;
  width: 350px;
`;

const StyledTitle = styled(DefaultHeader)`
  margin-top: ${Spacing.Large};
`;

class ErrorBoundary extends PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: unknown) {
    return { hasError: true };
  }

  componentDidCatch(error: Error | any) {
    handleError(error);
  }

  render() {
    const { hasError } = this.state;
    const { anErrorHasOccurred } = this.props.resource;
    if (hasError) {
      return (
        <StyledContainer>
          <StyledImage src={ErrorStateImg} alt={anErrorHasOccurred} />
          <StyledTitle>{anErrorHasOccurred}</StyledTitle>
        </StyledContainer>
      );
    }
    return this.props.children;
  }
}

export { ErrorBoundary };
